import { render } from "./ServiceDrive.vue?vue&type=template&id=6b4755fd&scoped=true"
import script from "./ServiceDrive.vue?vue&type=script&lang=js"
export * from "./ServiceDrive.vue?vue&type=script&lang=js"

import "./ServiceDrive.vue?vue&type=style&index=0&id=6b4755fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4755fd"]])

export default __exports__